import has from '@dojo/framework/core/has';
import { create, v, w } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/widgets/middleware/theme';
import { Store } from '@dojo/framework/stores/Store';

// make generated .d.ts file valid
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { WNodeFactory, WidgetProperties, DNode } from '@dojo/framework/core/interfaces';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ThemeProperties } from '@dojo/framework/core/middleware/theme';

import { ParentTree, PostTestResults } from '@holmescorp/lcc-state/interfaces';
import { userstate, createNlsMiddleware } from '@holmescorp/lcc-state';

import { PrePostViz } from '@holmescorp/prepost-viz';

import { QuizMeta } from '../interfaces';
import { quizstate } from '../support/state';

import css from '../css/module-results.m.css';

export interface ModuleProgressProperties {
	quizstore: Store<QuizMeta>;
}

const nls = createNlsMiddleware('quiz');
const factory = create({ theme, nls, quizstate, userstate }).properties<ModuleProgressProperties>();

// const lang = window.hcstatic.portal_language || 'en';
// const pct = new Intl.NumberFormat(lang, { style: 'percent', maximumSignificantDigits: 2 });

const isEmpty = (obj: any) => Object.keys(obj).length === 0;

export const ModuleProgress = factory(({ properties, middleware: { theme, quizstate, userstate } }) => {
	const { quizstore } = properties();
	quizstate.setStore(quizstore);
	const quiz = quizstate.get(quizstate.path('quiz'));
	const quizkind = quiz && quiz.kind;
	const { get, path } = userstate;

	let modules: ParentTree | undefined = undefined;
	let label = '';
	let useCutscores = false;
	let whichtest: 'posttest' | 'practice' = 'posttest';

	switch (quizkind) {
		case 'pretest':
			break;

		case 'posttest':
			{
				const posttest: PostTestResults = get(path('posttest'));
				if (posttest) {
					modules = posttest.tree;
					label = quiz ? quiz.title : 'Post-Test';
					whichtest = 'posttest';
				}
			}
			break;

		case 'practice':
			{
				const practice = get(path('practice'));
				if (practice) {
					modules = practice;
					label = quiz ? quiz.title : 'Post-Test';
					useCutscores = has('use-cutscores') ? true : false;
					whichtest = 'practice';
				}
			}
			break;
	}

	const status = get(path('status'));
	if (modules === undefined || !status) {
		return null;
	}

	const instancekey = quizstate.get(quizstate.path('instancekey'));
	const themeCss = theme.classes(css);

	const cutscores = () => {
		const info = quizstate.get(quizstate.path('info'));
		const quizPattern = get(path('quizPattern'));

		const lastresult = info && info.lastresult;
		if (!lastresult || isEmpty(lastresult)) {
			return null;
		}

		return v('section', { key: `modules-${instancekey}`, classes: [themeCss.cutscoreBlock] }, [
			w('CutScores', { key: `cutscores-${instancekey}`, label, modules, quizPattern })
		]);
	};

	if (useCutscores) {
		return cutscores();
	}

	return v('div', { key: `modules-${instancekey}`, classes: [themeCss.root] }, [w(PrePostViz, { whichtest })]);
});
